module.exports = __webpack_public_path__ + "static/img/2.5ff15586.png";